module.exports = __webpack_public_path__ + "static/media/about.2acf5ce7.jpg";